export default function TurboBallIcon() {
  return (
    <svg viewBox="0 0 64 64" aria-hidden="true">
      <rect x="2" y="48" width="60" height="12" rx="3" fill="#2E8B45" />
      <circle cx="40" cy="24" r="16" fill="#E9EFF7" stroke="#3A4A66" strokeWidth="2" />
      <circle cx="40" cy="24" r="4.5" fill="#3A4A66" />
      <circle cx="31" cy="17" r="3" fill="#3A4A66" />
      <circle cx="49" cy="17" r="3" fill="#3A4A66" />
      <circle cx="33" cy="33" r="3" fill="#3A4A66" />
      <circle cx="47" cy="33" r="3" fill="#3A4A66" />
      <path d="M2 44 L10 44 L4 40 Z" fill="#FF9F1C" />
      <path d="M8 46 V38 L16 36 L22 30 L30 31 L34 38 V46 Z" fill="#2F8BFF" stroke="#164787" strokeWidth="2" strokeLinejoin="round" />
      <path d="M19 37 L23 32 L28 32.5 L30 37 Z" fill="#BFE3FF" />
      <circle cx="14" cy="47" r="4.5" fill="#15181D" />
      <circle cx="28" cy="47" r="4.5" fill="#15181D" />
      <path d="M0 40 L8 41 M0 36 L6 37" stroke="#FFE36B" strokeWidth="2.5" strokeLinecap="round" />
    </svg>
  );
}
